<template>
    <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">

      <div class="pop-content-search">
        <el-form size="mini">
          <el-row :gutter="24">
<!--            <el-col :span="8">-->
<!--              <el-row>-->
<!--                <el-col :span="24">-->
<!--                  <el-form-item label="검색타입">-->
<!--                    <el-col :span="16">-->
<!--                      <el-select v-model="deptCd" placeholder="부서선택">-->
<!--                          <el-option label="선택" value="1"></el-option>-->
<!--                      </el-select>-->
<!--                    </el-col>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--              </el-row>-->
<!--            </el-col>-->
            <el-col :span="8">
              <el-form-item label="그룹">
                <el-select v-model="deptCd" placeholder="그룹선택">
                  <el-option label="선택" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="18">
                  <el-form-item label="사용자명">
                    <el-col :span="14">
                      <el-input type="input" v-model="search"></el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-button type="primary" icon="el-icon-search">
                          검색
                      </el-button>
                    </el-col>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>

          </el-row>
        </el-form>
        
      </div>

      <!-- grid s. -->
      <div class="grid-wrap">
        <div class="talbe-contain" style="display: flex;border: 1px solid #a6acb1;border-radius: 3px;">
<!--          <div class="table-area" style="margin-right: 50px; width: 20%;">-->
<!--              <div class="table-b">-->
<!--                <el-tree class="custom-tree" :data="trees" :props="defaultProps" @node-click="handleNodeClick" default-expand-all></el-tree>-->
<!--              </div>-->
<!--          </div>-->
          <div class="table-area" style="margin-right: 10px; width: 80%">
            <div class="table-b">
              <ag-grid-vue 
              style="width: 100%; height: 330px;"
              class="ag-theme-alpine"    
              row-selection="single"
              :column-defs="columnDefs"
              :grid-options="gridOptions"
              :row-data="data"
              :default-col-def="defaultColDef"
              @rowDoubleClicked="rowDoubleClick"
              @grid-ready="onGridReady"/>
            </div>
          </div>
        </div>
      </div>
      <!-- grid e. -->
<!--      <el-form size="mini" label-width="80px" style="margin: 10px 0 0 -10px;">-->
<!--        <el-row>-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="사용자ID">-->
<!--              <el-input></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="직책">-->
<!--              <el-input></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="이름">-->
<!--              <el-input></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row>-->
<!--          <el-form-item label="담당업무">-->
<!--            <el-input type="textarea"></el-input>-->
<!--          </el-form-item>-->
<!--        </el-row>-->
<!--        <el-row>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="전화번호">-->
<!--              <el-row>-->
<!--                <el-col :span="8">-->
<!--                  <el-select v-model="mobileGb">-->
<!--                    <el-option value='m' label="핸드폰"></el-option>-->
<!--                    <el-option value='h' label="전화번호"></el-option>-->
<!--                    <el-option value='i' label="내선"></el-option>-->
<!--                  </el-select>-->
<!--                </el-col>-->
<!--                <el-col :span="12">-->
<!--                  <el-input></el-input>-->
<!--                </el-col>-->
<!--              </el-row>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="6">-->
<!--            <el-form-item label="내선">-->
<!--              <el-input></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="6">-->
<!--            <el-form-item label="핸드폰">-->
<!--              <el-input></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </el-form>-->

    </div>
  </layout>
</template>

<script>
/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";

// import mixin from './index';

export default {
    // mixins: [mixin],
    props: {
        data: {
            Type: Array
            , required: false
        },
        custNo: {
            Type: String
            , required: false
        }
    },
    components: {Layout, AgGridVue},
    data() {
        return {
            title: '권한그룹추가',
            form: {
            },
            search: '',
            deptCd: '1',
            mobileGb: 'h',
            // AG-GRID OPTION [START]
            rowData:[],
            gridOptions: {},
            columnDefs:[],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            // trees: [{
            //     value: '전체',
            //     key: [{
            //         value: '고객센터',
            //         key:
            //         [{
            //           value: '총괄',
            //         },
            //         {
            //           value: '운영팀',
            //         },
            //         {
            //           value: '기술팀',
            //         },
            //         {
            //           value: '고객센터',
            //         },
            //         {
            //           value: '대우루컴즈',
            //         }
            //       ]
            //     }]
            // }],
            defaultProps: {
              children: 'key',
              label: 'value'
            }
        }
    },
    created() {
      this.form = this.data;

      this.$bus.$on('input', (val) => {
          console.log('-> input bus on ', val);
      });
    },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

  },
    mounted() {
        //pop slots modal move
        // $(".animation-content").addClass('pop_min2');
        // $(".animation-content").draggable({'cancel':'.modal-card-body'});
        // //ModalSlot open z-index change
        // $('.lnb').css('z-index', '4');
    },
    destroyed() {
        //ModalSlot open z-index change
        // $('.lnb').css('z-index', '7');
    },
    methods: {

        createColumnDefs(){

          this.columnDefs = [
            {
              headerName: '사용자ID',
              field:'userCd',
              width: 150,
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '사용자명',
              field:'userNm',
              width: 150,
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '직무',
              field:'work',
              width: 150,
              cellStyle:{textAlign:'left'}
            },
          ]
        },
        
        closeModal() {
            this.$parent.close();
        },
        handleNodeClick(data) {
            console.log(data);
        },
        onGridReady(){
        
        },
        rowDoubleClick(params){
            this.$emit('close', params.data);
        },
        onCellClicked(params) {
            const field = params.colDef.field;
        },
    }

}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}
</style>